import { useState } from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";

const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to a backend endpoint
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 8000);
    setForm({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <section id="contact" className="lp-contact">
      <div className="lp-contact__inner">
        <div className="lp-section-header lp-section-header--light">
          <span className="lp-section-tag lp-section-tag--light">Get In Touch</span>
          <h2>Have Questions? We're Here to Help</h2>
          <p>Reach out to learn how this platform can work for your team.</p>
        </div>

        <div className="lp-contact__grid">
          <div className="lp-contact__info">
            <div className="lp-contact__info-card">
              <FaEnvelope />
              <div>
                <strong>Email Us</strong>
                <span>support@example.com</span>
              </div>
            </div>
            <div className="lp-contact__info-card">
              <FaPhone />
              <div>
                <strong>Call Us</strong>
                <span>+1 (555) 123-4567</span>
              </div>
            </div>
            <div className="lp-contact__info-card">
              <FaMapMarkerAlt />
              <div>
                <strong>Visit Us</strong>
                <span>Your City, Your Country</span>
              </div>
            </div>
          </div>

          <form className="lp-contact__form" onSubmit={handleSubmit}>
            {submitted && (
              <div className="lp-contact__success">
                <FaPaperPlane /> Thank you! We'll get back to you soon.
              </div>
            )}
            <div className="lp-contact__form-row">
              <input
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                name="email"
                type="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <input
              name="subject"
              placeholder="Subject"
              value={form.subject}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              value={form.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="lp-btn lp-btn--primary">
              <FaPaperPlane /> Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
